/**
 * Generated by orval
 * Do not edit manually
 * WorkflowXMApi, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type WorkflowItemStatus = (typeof WorkflowItemStatus)[keyof typeof WorkflowItemStatus];

export const WorkflowItemStatus = {
  Active: 0,
  Pending: 1,
  Approved: 2,
  Denied: 3,
  Completed: 4,
  Dropped: 5,
} as const;
